import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { SkuIdInfoService } from '../../../../app/core/routing/services/sku-ids/sku-id-info.service';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { SKUCompareRespondeModal } from '../../../../app/core/routing/services/sku-ids/sku-id-info.i';

@Component({
  selector: 'iposcen-compare-sku-ids',
  templateUrl: './compare-sku-ids.component.html',
  styleUrls: ['./compare-sku-ids.component.scss']
})
export class CompareSkuIdsComponent implements OnInit {
  allSkuList:any[]=[];
  skuList:any[];
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  globalconst = GlobalConstants;
  selectedItem:any;
  copySelectedItem:any;
  isDataLoading:boolean = true;
  showDuplicatesError:boolean =false;
  checkingSet= GlobalConstants.skuChkSet;
  private ngUnsubscribe = new Subject<boolean>();
  searchByNamePlaceholderText:string = this.globalconst.PLACEHOLDER_TEXT;
  allSkuLists:any[]=[];
  constructor(private skuIdService: SkuIdInfoService) { }

  ngOnInit(): void {
    this.getAllSkuList();
  }
  // To get List of sku-info IIT2-6607
  getAllSkuList() {
    this.allSkuList = [];
    this.skuList =[];
    this.selectedItem={};
    this.copySelectedItem={};
    this.skuIdService.getAllSkuInfoByUSer()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllSkuList => {
        this.isDataLoading = false;
        this.allSkuList = getAllSkuList.skuContent;
        this.allSkuLists=this.allSkuList;
        getAllSkuList.skuContent.forEach(element => {
          if (element.updatedTime) {
            element.updatedTime = new Date(element.updatedTime);
          }
          this.skuList.push({
            internalName: element?.internalName,
            skuId: element?.skuID,
            publishedName: element?.publishedName
          });
          this.selectedItem[element?.skuID]={};
          this.selectedItem[element?.skuID].allSKUArray=[];
          this.selectedItem[element?.skuID].compareSet = {};
          if(element?.skuList?.skuCompareList?.sku2){
            this.selectedItem[element?.skuID].sku2 = {
              internalName: element?.skuList?.skuCompareList?.sku2?.internalName,
              skuId: element?.skuList?.skuCompareList?.sku2?.skuId,
              publishedName: element?.skuList?.skuCompareList?.sku2?.skuCode
            };
            this.selectedItem[element?.skuID].allSKUArray.push(element?.skuList?.skuCompareList?.sku2?.skuId);
            this.selectedItem[element?.skuID].compareSet.sku2 = element?.skuList?.skuCompareList?.sku2?.skuId;
          }
          if(element?.skuList?.skuCompareList?.sku3){
            this.selectedItem[element?.skuID].sku3 = {
              internalName: element?.skuList?.skuCompareList?.sku3?.internalName,
              skuId: element?.skuList?.skuCompareList?.sku3?.skuId,
              publishedName:element?.skuList?.skuCompareList?.sku3?.skuCode
            };
            this.selectedItem[element?.skuID].allSKUArray.push(element?.skuList?.skuCompareList?.sku3?.skuId);
            this.selectedItem[element?.skuID].compareSet.sku3 = element?.skuList?.skuCompareList?.sku3?.skuId;
          }
          if(element?.skuList?.skuCompareList?.sku4){
            this.selectedItem[element?.skuID].sku4 = {
              internalName: element?.skuList?.skuCompareList?.sku4?.internalName,
              skuId: element?.skuList?.skuCompareList?.sku4?.skuId,
              publishedName: element?.skuList?.skuCompareList?.sku4?.skuCode
            };
            this.selectedItem[element?.skuID].allSKUArray.push(element?.skuList?.skuCompareList?.sku4?.skuId);
            this.selectedItem[element?.skuID].compareSet.sku4 = element?.skuList?.skuCompareList?.sku4?.skuId;
          }
          if(element?.skuList?.skuCompareList?.sku5){
            this.selectedItem[element?.skuID].sku5 = {
              internalName: element?.skuList?.skuCompareList?.sku5?.internalName,
              skuId: element?.skuList?.skuCompareList?.sku5?.skuId,
              publishedName: element?.skuList?.skuCompareList?.sku5?.skuCode
            };
            this.selectedItem[element?.skuID].allSKUArray.push(element?.skuList?.skuCompareList?.sku5?.skuId);
            this.selectedItem[element?.skuID].compareSet.sku5 = element?.skuList?.skuCompareList?.sku5?.skuId;
          }
        });
        for(let i=0;i<this.allSkuList?.length;i++){
          this.allSkuList[i].filterSKUData=this.filterData(this.allSkuList[i]?.skuID);
          this.allSkuList[i].duplicateFlag = false;
        }
        this.allSkuList.sort((sku1, sku22) => sku22.updatedTime - sku1.updatedTime);
      },
      error => {});
  }
  //To compare the selectedData with select options
  compareWith(item, selected) {
    return item.publishedName === selected.publishedName
  }
  //OnClick of save changes
  saveChanges(){
    let check = this.checkDuplicates();
    if(!check){
      this.showDuplicatesError = false;
      let saveData = { skuCompareRequest : [] };
      for(let eachKey in this.selectedItem){
        if(Object.keys(this.selectedItem[eachKey])?.length > 3){
          delete this.selectedItem[eachKey]?.duplicateFlag; 
          delete this.selectedItem[eachKey]?.allSKUArray; 
          delete this.selectedItem[eachKey]?.compareSet;  // removing unnecessary metadata keys which are not req for api payload. 
          for(let ek in this.checkingSet){
            delete this.selectedItem[eachKey][this.checkingSet[ek]]?.publishedName;
          }
          saveData.skuCompareRequest.push(
            {
              baseSkuId: eachKey,...this.selectedItem[eachKey]
            }
          )
        }
      }
      this.isDataLoading = true;
      if(saveData.skuCompareRequest?.length){
        this.skuIdService.updateCompareSKUData(saveData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(upDatedResp => {
          this.getAllSkuList();
        });
      }else{
        this.getAllSkuList();
      }
    }else{
      this.showDuplicatesError = true;
    }
  }
  // function to save data on selected.
  onSKUChange(data,sku,number){
    this.selectedItem[sku][number] = data;
    if(data){
      if(this.selectedItem[sku].allSKUArray?.length) {
        this.selectedItem[sku].allSKUArray.push(data?.skuId);
      }else{ 
        this.selectedItem[sku].allSKUArray = [data?.skuId];
      }
      this.selectedItem[sku].compareSet[number] =data?.skuId;
    }else{
      //Remove data from MetaData when user un-selects the item in ng-select
      this.selectedItem[sku].allSKUArray = this.selectedItem[sku].allSKUArray.filter(d=>{ return d!== this.selectedItem[sku].compareSet[number]});
      delete this.selectedItem[sku].compareSet[number];
    }
  }
  //Revert Changes - Cancel
  revertChanges(){
    this.isDataLoading = true;
    this.getAllSkuList();
  }
  // Function to return matched content on search.
  SKUSearchFn(term: string, item: any) {
    return item?.internalName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase()) || item?.publishedName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase());
  }
  //IIT2-6607 end
  filterData(filterid){
    let selctData = this.skuList.filter(d=>{ return d.skuId !== filterid})
    return selctData;
  }
  checkDuplicates(){
    let duplicatesFlg = false;
    for(let eachKey in this.selectedItem){
      let results =[];
      this.selectedItem[eachKey].duplicateFlag = {};
      if(this.selectedItem[eachKey]?.allSKUArray?.length){
        results= this.selectedItem[eachKey].allSKUArray.filter((itm, i) =>{
            return this.selectedItem[eachKey].allSKUArray.lastIndexOf(itm)== i && this.selectedItem[eachKey].allSKUArray.indexOf(itm)!= i;
        });
        if(results?.length){
          if(!duplicatesFlg){ //Once set dont allow to re-set;
            duplicatesFlg = true;
          }
          for(var i in this.checkingSet){
            if(results.indexOf(this.selectedItem[eachKey].compareSet?.[this.checkingSet[i]]) >=0){
              this.selectedItem[eachKey].duplicateFlag[this.checkingSet[i]] = true;
            }else{
              this.selectedItem[eachKey].duplicateFlag[this.checkingSet[i]] = false;
            }
          }
        }
      }
    }
    return duplicatesFlg;
  }

  onChangeSKU(val){
    this.allSkuList=this.allSkuLists;
    const arrList=[];
    for(let i=0;i<this.allSkuList?.length;i++){
    if(val.skuId === this.allSkuList[i]?.skuID){
      arrList.push(this.allSkuList[i]);
    }
  }
  this.allSkuList=arrList;
  }  
}
